import * as React from "react";

import Button from "@material-ui/core/Button";
import { DetailActionProps, getNextPage } from "../detail-actions-props";
import RejectIcon from "@material-ui/icons/Cancel";
import LoadingIcon from "@material-ui/icons/Timelapse";
import { MessageDialog } from "../message-dialog";
import { reject as rejectRelease } from "../../../../../sdk/release";
import { useHistory, useLocation } from "react-router";
import { handleReleaseRejected } from "../../../../../utils/rudderstack/events";

export const RejectRelease: React.FC<DetailActionProps> = (props) => {
  const { data } = props;
  const history = useHistory();
  const location = useLocation<{from?: string}>();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleReject = async (message: string) => {
    setLoading(true);
    setOpen(false);

    await Promise.all(
      data.map(async ({ release, assets, tracks }) => {
        await rejectRelease(
          release.id,
          release.UPCEAN as string,
          `${release.id}.json`,
          !!assets?.some((a) => a.category === "video"),
          release.cover.url,
          release.title,
          message
        );
        await handleReleaseRejected({ release, tracks });
      })
    );

    setLoading(false);

    props.onAction(data.map(({ release }) => release.id));

    history.push(getNextPage(location.state?.from), location.state);
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        endIcon={loading ? <LoadingIcon /> : <RejectIcon />}
        onClick={() => setOpen(true)}
      >
        Reject
      </Button>

      <MessageDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        onSend={handleReject}
        title={`Reject: ${
          data.length === 1 ? data[0].release.title : `${data.length} releases`
        }`}
        macros={props.macros}
      />
    </>
  );
};
